import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import { number, string, pointName } from "../../../../utils";

import styles from "./styles.scss";
import dateTime from "../../../../utils/dateTime";

let count = 0;
const idPrefix = "DiagnosticOutput";

@CSSModules(styles, { allowMultiple: true })
class DiagnosticOutput extends Component {
	constructor(props) {
		super(props);
		this.props.initTable(this.props.id, this.props.ruleInstance);
	}
	render() {
		if (!this.props.tableData) {
			return <div />;
		}
		return (
			<div styleName="component-wrapper">
				<div styleName="component-title">Diagnostic Actions</div>
				<table styleName="diagnostics-table">
					<thead>
						<tr>
							<th styleName="table-header" left="true">Date & Time</th>
							<th styleName="table-header" left="true">Point</th>
							<th styleName="table-header" left="true">Action</th>
							<th styleName="table-header">Value</th>
						</tr>
					</thead>
					<tbody>
						{this.props.tableData.rows.map((row, index) => (
							<tr key={index} styleName="diagnostic-data">
								<td >{dateTime.dateAndTime(row.time)}</td>
								<td>{pointName.formatDescription(row)}</td>
								<td>{row.action}</td>
								<td styleName="diagnostic-value">{number.parseNumber(row.value)}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	setup() {
		this.props.loadData(this.props.id, this.props.ruleInstance, this.props.timePeriod);
	}

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.tableData != this.props.tableData) {
			return true;
		} else if (prevProps.ruleInstance != this.props.ruleInstance || prevProps.timePeriod != this.props.timePeriod) {
			this.setup();
			return false;
		} else {
			return false;
		}
	}
}

const bindAction = dispatch => {
	return {
		loadData: (id, ruleInstance, timePeriod) => dispatch(actions.loadData(id, ruleInstance, timePeriod)),
		initTable: (id, ruleInstance) => dispatch(actions.initTable(id, ruleInstance))
	};
};

const mapStateToProps = (state, ownProps) => ({
	tableData: state.diagnosticstable.instances[ownProps.id]
});

//do this to merge classes
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			wrapped: null
		};
		this.id = idPrefix + count;
		count++;
	}

	componentWillMount() {
		this.setState({
			wrapped: connect(
				mapStateToProps,
				bindAction
			)(DiagnosticOutput)
		});
	}

	render() {
		const Elem = this.state.wrapped;
		return <Elem {...this.props} id={this.id} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Tables/DiagnosticOutput/DiagnosticOutput.js